
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function EmploymentListPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white">
      {/* Header */}
      <header className="relative z-50">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            {/* Logo and Brand */}
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-14 h-14 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/dcd65f13a790094d0aa5adf5c5f61db5/d92e14626dcee2662ced5b45bc6a77f4.png"
                  alt="Tactical Arms Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">Tactical Arms</h1>
                <p className="text-sm text-gray-300">NXT Cam Properties • Firearms • Ammunition • Tactical Gear</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                Home
              </Link>
              <Link to="/official-discounts" className="text-gray-300 hover:text-white transition-colors">
                Official Discounts
              </Link>
              <Link to="/shop" className="text-gray-300 hover:text-white transition-colors">
                Shop
              </Link>
              <Link to="/employee-application" className="text-gray-300 hover:text-white transition-colors">
                Employee Application
              </Link>
              <Link to="/employment-list" className="text-yellow-400 font-medium border-b-2 border-yellow-400 pb-1">
                Employment List
              </Link>
              <div className="relative group">
                <button className="text-gray-300 hover:text-white transition-colors flex items-center space-x-1">
                  <span>Blacklists</span>
                  <i className="ri-arrow-down-s-line"></i>
                </button>
                <div className="absolute top-full left-0 mt-2 w-64 bg-gray-800 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                  <div className="py-2">
                    <Link to="/blacklists/player-blacklists" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700 transition-colors">
                      Player Blacklists
                    </Link>
                    <Link to="/blacklists/business-mafia-blacklists" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700 transition-colors">
                      Business/Mafia Blacklists
                    </Link>
                  </div>
                </div>
              </div>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-white hover:text-yellow-400 transition-colors"
            >
              <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden mt-4 bg-gray-800 rounded-lg p-4">
              <nav className="flex flex-col space-y-3">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors py-2">
                  Home
                </Link>
                <Link to="/official-discounts" className="text-gray-300 hover:text-white transition-colors py-2">
                  Official Discounts
                </Link>
                <Link to="/shop" className="text-gray-300 hover:text-white transition-colors py-2">
                  Shop
                </Link>
                <Link to="/employee-application" className="text-gray-300 hover:text-white transition-colors py-2">
                  Employee Application
                </Link>
                <Link to="/employment-list" className="text-yellow-400 font-medium py-2">
                  Employment List
                </Link>
                <div className="border-t border-gray-700 pt-3 mt-3">
                  <p className="text-gray-400 text-sm mb-2">Blacklists</p>
                  <Link to="/blacklists/player-blacklists" className="text-gray-300 hover:text-white transition-colors py-2 pl-4 block">
                    Player Blacklists
                  </Link>
                  <Link to="/blacklists/business-mafia-blacklists" className="text-gray-300 hover:text-white transition-colors py-2 pl-4 block">
                    Business/Mafia Blacklists
                  </Link>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Page Header */}
      <section className="py-16 bg-gray-900/50">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              Employment List
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Current employees at Tactical Arms by NXT Cam Properties. Our dedicated team of professionals committed to excellence in firearms and tactical equipment.
            </p>
          </div>
        </div>
      </section>

      {/* Google Sheets Embed */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="bg-white rounded-xl overflow-hidden shadow-2xl">
            <iframe
              src="https://docs.google.com/spreadsheets/d/1XqcE2fND2o0WY9UEUJOOV3u58XuWwTnOtOx-AbYWygw/edit?gid=1030820184&rm=minimal"
              width="100%"
              height="800"
              className="border-0"
              title="Employment List Spreadsheet"
            ></iframe>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-yellow-600 to-yellow-500">
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-3xl font-bold text-black mb-4">
            Join Our Team
          </h3>
          <p className="text-lg text-black/80 mb-6 max-w-2xl mx-auto">
            Interested in working with us? We're always looking for dedicated professionals to join our team at Tactical Arms.
          </p>
          <Link 
            to="/employee-application" 
            className="bg-black text-yellow-400 hover:bg-gray-900 font-bold py-3 px-8 rounded-lg transition-colors whitespace-nowrap cursor-pointer inline-block"
          >
            Apply Now
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center">
                  <img 
                    src="https://static.readdy.ai/image/dcd65f13a790094d0aa5adf5c5f61db5/d92e14626dcee2662ced5b45bc6a77f4.png"
                    alt="Tactical Arms Logo"
                    className="w-full h-full object-contain"
                  />
                </div>
                <span className="text-xl font-bold text-white">Tactical Arms</span>
              </div>
              <p className="text-gray-400 leading-relaxed">
                Your trusted source for premium firearms, ammunition, and tactical equipment. A division of NXT Cam Properties.
              </p>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/shop" className="text-gray-400 hover:text-yellow-400 transition-colors">Shop</Link></li>
                <li><Link to="/official-discounts" className="text-gray-400 hover:text-yellow-400 transition-colors">Discounts</Link></li>
                <li><Link to="/employee-application" className="text-gray-400 hover:text-yellow-400 transition-colors">Careers</Link></li>
                <li><Link to="/employment-list" className="text-gray-400 hover:text-yellow-400 transition-colors">Employment</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Blacklists</h4>
              <ul className="space-y-2">
                <li><Link to="/blacklists/player-blacklists" className="text-gray-400 hover:text-yellow-400 transition-colors">Player Blacklists</Link></li>
                <li><Link to="/blacklists/business-mafia-blacklists" className="text-gray-400 hover:text-yellow-400 transition-colors">Business/Mafia Blacklists</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Contact Info</h4>
              <div className="space-y-2 text-gray-400">
                <p>Licensed Firearms Dealer</p>
                <p>Professional Grade Equipment</p>
                <p>NXT Cam Properties</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Tactical Arms - NXT Cam Properties. All rights reserved.
            </p>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}